// extracted by mini-css-extract-plugin
export var errorsContainer = "_rq-1";
export var link = "_rq-0";